import PopoverCoordinator from '@intercom/embercom-composer/components/popover-coordinator';
export default PopoverCoordinator;
